import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Select = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 10px 5px;
  width: 100%;
  min-height: 2.18rem;
  outline: 1px solid var(--color);
`;

export const Options = styled.div`
  position: absolute;
  padding: 5px;
  margin-top: 5px;
  outline: 1px solid var(--color);
  background: var(--background-color);
  animation: animacao 0.2s ease forwards;
  @keyframes animacao {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

export const Option = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  & + & {
    border-top: 1px solid var(--color);
  }
`;

export const Label = styled.label`
  padding: 10px;
`;

export const Input = styled.input`
  margin-left: 10px;
`;

export const Info = styled.p`
  font-weight: 400;
`;
